export function isNetworkError(error) {
    return (
        !error ||
        (!error.response && !error.data) ||
        error.code === 'ECONNABORTED' // ECONNABORTED is timeout
    );
}
